// extracted by mini-css-extract-plugin
var _1 = "t2K0";
var _2 = "t2KZ";
export { _1 as "footer", _2 as "scrolled" }
